module.exports = __webpack_public_path__ + "static/media/step8.a888fcaa.png";